import React, { useEffect, useState } from 'react'
import { FileRejection, useDropzone } from 'react-dropzone'
// @ts-ignore
import { FormFeedback } from 'reactstrap'
import { Messages } from './constants'
import { Container, Wrapper } from './styles'

interface DropzoneProps {
  onDrop: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void
  maxFiles?: number
  title: string
  accept?: any
  isInvalid?: boolean
  validationMessage?: string
}

export const Dropzone: React.FC<DropzoneProps> = ({
  onDrop,
  maxFiles,
  title,
  accept = 'image/*',
  isInvalid = false,
  validationMessage = ''
}: DropzoneProps) => {
  const [errorMessage, setErrorMessage] = useState<string>(validationMessage)
  const [invalid, setInvalid] = useState(isInvalid)
  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop,
    maxFiles,
    accept
  })

  useEffect(() => {
    if (fileRejections?.length > 0) {
      fileRejections.every(({ file, errors }: any) => {
        let errorMessage: string
        switch (errors[0].code) {
          case 'file-invalid-type': {
            errorMessage = Messages.FILE_INVALID_TYPE
            break
          }
          case 'too-many-files': {
            errorMessage = `${Messages.TOO_MANY_FILES} ${maxFiles}`
            break
          }
          default: {
            errorMessage = errors[0].message
          }
        }

        setInvalid(true)
        setErrorMessage(errorMessage)
        return false
      })
    }
  }, [fileRejections, maxFiles])

  return (
    <>
      <Wrapper
        isInvalid={invalid}
        {...getRootProps({ className: `dropzone ${invalid && 'is-invalid'}` })}>
        <Container className="dropzone-content">
          <input className="input-zone" {...getInputProps()} />
          {isDragActive ? (
            <span className="font-medium-2">Drop your files here</span>
          ) : (
            <>
              <span className="font-medium-2 text-center">{title}</span>
              <span className="pt-1 font-medium-2"> Or </span>
              <span className="pt-1 font-medium-2"> Click to select files </span>
              <span className="pt-1 text-muted">(files supported .png .jpg)</span>
            </>
          )}
        </Container>
      </Wrapper>
      {errorMessage && <FormFeedback className="d-block">{errorMessage}</FormFeedback>}
    </>
  )
}
